var _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTakePhoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 73,
    viewBox: "0 0 72 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36.5127,
    r: 34.5,
    stroke: "white",
    strokeWidth: 3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36.5127,
    r: 30,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTakePhoto);
export default __webpack_public_path__ + "static/media/takePhoto.7ccc27b866a2d032d2c8220bd4e34dbc.svg";
export { ForwardRef as ReactComponent };